import React, { Component } from 'react';
import classNames from 'classnames';
import FullScreenLoading from '../../shared/components/misc/FullScreenLoading';
import { createPaymentSchedules, confirmDrawDown } from '../loanOfferActions';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import Layout from '../../shared/components/layouts/MainLayout';
import AmortizingDisbursement from '../components/AmortizingDisbursement';
import AmortizingRepayment from '../components/AmortizingRepayment';
import { segmentEventTracker } from '../../../utils/SegmentEventTracker';
import {
  TrackEventName,
  PageViewName,
} from '../../shared/constants/SegmentEvents';
import AmortizingDetails from '../components/AmortizingDetails';
import SchedulePayloadBuilder from '../../../utils/SchedulePayloadBuilder';
import CutoffSelector from '../../../utils/CutoffSelector';
import Formatters from '../../../features/shared/utils/Formatters';
import isEmpty from 'is-empty';

export class ReviewDrawDownDetails extends Component {
  constructor(props) {
    super(props);

    let defaultState = {
      loading: false,
      breakdownView: false,
      customizedLoanOffer: props.loanOffer,
      currentSchedule: props.loanOffer.selectedOption,
      currentOption: {},
      currentOptionIndex: null,
    };
    this.state = defaultState;
    this.onConfirm = this.onConfirm.bind(this);
  }

  componentDidMount() {
    this.trackPageView();
    const {loanOffer, push } = this.props
    if(!loanOffer.custom_fields) push('/draw_down');
  }

  onConfirm = () => {
    const {
      id,
      pre_cutoff_live_date,
      post_cutoff_live_date,
    } = this.props.credit_line;
    const selected_cutoff_date = CutoffSelector({
      preCutoffDate: pre_cutoff_live_date,
      postCutoffDate: post_cutoff_live_date,
    });
    const pastCutoff = selected_cutoff_date === post_cutoff_live_date;
    const {
      custom_fields:{
        disbursed_amount,
        service_fee,
        service_fee_amount,
        schedule_id
      },
      selectedOption: {
        start_date
      }
    } = this.props.loanOffer;
    const isScheduleUpdated = start_date !== selected_cutoff_date;

    this.trackAcceptClick();
    if (pastCutoff && isScheduleUpdated) {
      this.updatePaymentSchedule();
    } else {
      const calc_service_fee_amount =
        service_fee === 0 ? 0 : service_fee_amount;
      this.props.confirmDrawDown(
        this.props.userId,
        {
          disbursed_amount,
          fc_payment_id: this.props.fcPayment.id,
          id,
          schedule_id,
          service_fee,
          service_fee_amount: calc_service_fee_amount,
        },
        (loanOfferId) => {
          this.onSuccess(loanOfferId);
        }
      );
    }
  };

  updatePaymentSchedule = () =>{
    const {
      createPaymentSchedules,
      credit_line: {
        convenience_fee_type,
        id,
        pre_cutoff_live_date,
        post_cutoff_live_date,
      },
      companyId,
      loanOffer: {
        selectedOption: {
          frequency,
          frequency_mode,
          interest_rate,
          term_length,
          term_mode,
          principal_amount: principalAmount,
        }
      },
    } = this.props;
    const defaultTermMode = term_mode || 'month'
    const payload = SchedulePayloadBuilder({
      convenienceFeeType: convenience_fee_type,
      frequency,
      frequencyMode: frequency_mode,
      interestRate: interest_rate,
      preCutoffDate: pre_cutoff_live_date,
      postCutoffDate: post_cutoff_live_date,
      principalAmount,
      termLength: term_length,
      termMode: defaultTermMode,
      paymentId: this.props.payment.id,
    });
    createPaymentSchedules(
      companyId,
      payload,
      (response) => {
        const service_fee = payload['schedules'][0]['service_fee'];
        const selectedScheduleId = response.data.data.id;
        const service_fee_amount =
          service_fee === 0 ? 0 : principalAmount * (service_fee / 100.0);
        const disbursed_amount = principalAmount - service_fee_amount;
        const confirmationPayload = {
          disbursed_amount,
          fc_payment_id: this.props.fcPayment.id,
          id,
          schedule_id: selectedScheduleId,
          service_fee,
          service_fee_amount,
        };
        this.props.confirmDrawDown(
          this.props.userId,
          confirmationPayload,
          (loanOfferId)=>{ this.onSuccess(loanOfferId); }
        );
    })
  }

  onSuccess(loanOfferID){
    const successfulDrawDownRoute = this.isForPayment ? '/draw_down/completed' : '/draw_down/requested';

    this.props.push({pathname: successfulDrawDownRoute});
  }

  get confirmButtonClassNames() {
    return classNames('ds-btn', '--block', '_verticalPadding--large', {
      _loading: this.props.loading.default,
    });
  }

  get isForPayment() {
    return !isEmpty(this.props.fcPayment);
  }

  get header() {
    if (this.isForPayment) {
      return 'Review Your Payment Details'
    }

    return 'Review Your Loan Details'
  }

  trackPageView() {
    segmentEventTracker.trackPageView(
      PageViewName.LOAN_OFFER_ACCEPTANCE_SUMMARY_VIEWED
    );
  }

  trackAcceptClick() {
    segmentEventTracker.trackEvent(TrackEventName.ACCEPT_LOAN_OFFER_CLICKED);
  }

  backButtonAction = () => {
    segmentEventTracker.trackEvent(TrackEventName.BACK_CLICKED);
    this.props.push('/draw_down');
  };

  changePaymentTermsAction = () => {
    this.props.push('/draw_down');
  };

  toggleBreakdownView = () => {
    this.setState({ breakdownView: !this.state.breakdownView }, () => {
      segmentEventTracker.trackEvent(
        TrackEventName.LOAN_OFFER_BREAKDOWN_CLICKED,
        { action: this.state.breakdownView ? 'View' : 'Hide' }
      );
    });
  };

  renderPaymentDetails = () => {
    const {
      payment_date,
      supplier: {
        id,
        bank_account_number,
        business_name,
        bank: { bank_name }
      }
    } = this.props.fcPayment;

    return (
        <section
          className='cardSection _paddingBottom--none'
        >
          <p className='_textAlign_center subhead -primary _marginBottom--large _marginTop--xxsmall'>Payment will be sent to</p>
          <h2 className='subhead _fontSize--large -darkBlue _displayFlex _alignItems-center _marginLeft--normal _marginRight--normal _marginBottom--xxsmall'>{ business_name }</h2>
          <p className='subhead -primary _fontSize--small _marginBottom--large _textAlign_left _marginLeft--normal'
          >
            <a target='_blank' href={`${process.env.REACT_APP_FCHUB_URL}/leads/${this.props.leadId}/suppliers/${id}`}>
              More Supplier Details
            </a>
          </p>
          <div className='_marginLeft--normal _marginRight--normal'>
            <div className='_displayFlex _justifyContent-space-between _alignItems-center _paddingBottom--small'>
              <p className='subhead _marginBottom--none _textAlign_left _fontSize--normal-mobileOnly _marginRight--small-mobileOnly'>
                Payment Date
              </p>
              <p
                className='_fontSize--normal-mobileOnly _whiteSpace_nowrap'
              >
                { Formatters.date(payment_date) }
              </p>
            </div>
            <div className='_displayFlex _justifyContent-space-between _alignItems-center _paddingBottom--small'>
              <p className='subhead _marginBottom--none _textAlign_left _fontSize--normal-mobileOnly _marginRight--small-mobileOnly'>
                Bank Name
              </p>
              <p
                className='_fontSize--normal-mobileOnly _whiteSpace_nowrap'
              >
                { bank_name }
              </p>
            </div>
            <div className='_displayFlex _justifyContent-space-between _alignItems-center _paddingBottom--large'>
              <p className='subhead _marginBottom--none _textAlign_left _fontSize--normal-mobileOnly _marginRight--small-mobileOnly'>
                Bank Account No.
              </p>
              <p
                className='_fontSize--normal-mobileOnly _whiteSpace_nowrap'
              >
                { bank_account_number }
              </p>
            </div>
          </div>
        </section>
    )
  }

  renderBreakdownToggle() {
    return (
      <button
        className='ds-btn -secondary --full'
        onClick={this.toggleBreakdownView}
        data-test='breakdown-toggle'
      >
        {this.state.breakdownView ? 'Hide' : 'View'} Breakdown
        <i className='materialIcon -secondary'>
          {this.state.breakdownView
            ? 'keyboard_arrow_up'
            : 'keyboard_arrow_down'}
        </i>
      </button>
    );
  }

  renderRepaymentDate() {
    const {
      loanOffer,
    } = this.props;
    const {
      equivalent_aor,
      frequency: repayment_frequency,
      frequency_mode: repayment_frequency_mode,
      payment_schedules,
      start_date: go_live_date,
      total: repayment_amount,
      term_length: repayment_term_length,
      term_mode: repayment_term_length_mode,
    } = loanOffer.selectedOption;
    const { service_fee, service_fee_amount } = loanOffer.custom_fields;
    let repayment_date = loanOffer.selectedOption.repayment_date;

    // LMS will not return a repayment date for amortizing plans.
    if (repayment_frequency_mode !== 'bullet') {
      repayment_date = payment_schedules[payment_schedules.length - 1]['due_date']
    }

    return (
      <AmortizingRepayment
        loanOffer={loanOffer}
        paymentPlan={loanOffer.selectedOption}
        goLiveDate={go_live_date}
        interestRate={equivalent_aor}
        repaymentAmount={repayment_amount}
        repaymentAmountPer={payment_schedules[0].total}
        repaymentDate={repayment_date}
        repaymentFrequency={repayment_frequency}
        repaymentFrequencyMode={repayment_frequency_mode}
        serviceFee={service_fee}
        serviceFeeAmount={service_fee_amount}
        termLength={repayment_term_length}
        termLengthMode={repayment_term_length_mode}
        paymentsCount={payment_schedules.length}
      />
    );
  }

  renderDisbursement() {
    const { loanOffer } = this.props;
    return (
      <AmortizingDisbursement
        loanOffer={loanOffer}
        paymentPlan={loanOffer.selectedOption}
        isForPayment={this.isForPayment}
      />
    );
  }

  renderAmortizingDetails() {
    const { loanOffer } = this.props;
    const { payment_schedules, start_date, total, interest, equivalent_aor } = loanOffer.selectedOption;
    let { interest_amount, repayment_amount } = loanOffer.custom_fields;
    let schedule = payment_schedules[0];

    interest_amount = schedule.interest;
    repayment_amount = schedule.total;

    return (
      <AmortizingDetails
        disbursed_amount={loanOffer.custom_fields.disbursed_amount}
        interest_amount={interest_amount}
        payment_schedules={payment_schedules}
        repayment_amount={repayment_amount}
        service_fee={loanOffer.custom_fields.service_fee}
        service_fee_amount={loanOffer.custom_fields.service_fee_amount}
        start_date={start_date}
        total_repayment_amount={total}
        total_interest_amount={interest}
        equivalent_aor={equivalent_aor}
        isForPayment={this.isForPayment}
      />
    );
  }

  renderChangePaymentTerms = () => {
    return (
      <div className='_displayFlex _justifyContent-center'>
        <button
          className='ds-btn _outline _centered _marginTop--medium'
          data-testid='change-payment-terms-button'
          onClick={this.changePaymentTermsAction}
        >
          <i
            style={{ color: '#565ef0' }}
            className='materialIcon -primary --small'
          >
            navigate_before
          </i>
          <span data-testid='change-payment-terms-button-copy'>
            Change loan terms
          </span>
        </button>
      </div>
    );
  };

  render() {
    const { loading } = this.props;
    const { customizedLoanOffer: loanOffer } = this.state;
    const {
      custom_fields,
      is_accepted,
      is_expired,
    } = loanOffer;
    if (is_accepted || is_expired) {
      this.props.push('/');
      return null;
    }
    let isLoading = loading.default || loading.paymentSchedules || !custom_fields;
    if (isLoading) return <FullScreenLoading />;

    return (
      <Layout
        gridClassName='--narrow'
        backButtonAction={this.backButtonAction}
        header={this.header}
      >
        <div className='ds-card _textAlign_center'>
          {this.isForPayment && this.renderPaymentDetails()}
          {this.renderDisbursement()}
          {this.renderRepaymentDate()}
          {this.renderAmortizingDetails()}
        </div>

        <button
          className={this.confirmButtonClassNames}
          disabled={loading.default}
          onClick={this.onConfirm}
          data-schedule-id={custom_fields.schedule_id}
          data-testid='confirm-drawdown-button'
        >
          Confirm
        </button>
        {this.renderChangePaymentTerms()}
      </Layout>
    );
  }
}

ReviewDrawDownDetails.defaultProps = {
  loanOffer: {
    customFields: {},
    flex_date_options: [],
    buyer: {},
  },
};

const mapStateToProps = (state) => {
  return {
    userId: state.user.id,
    companyId: state.company.id,
    loanOffer: state.loanOffers.loanOffer,
    credit_line: state.creditLine,
    loading: state.shared.ui.loading,
    fcPayment: state.fc_payment,
    leadId: (state.user.active_business_trustpass || {}).lead_id,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    push: (url) => dispatch(push(url)),
    createPaymentSchedules: (leadID, params, onSuccess, onError) =>
      dispatch(createPaymentSchedules(leadID, params, onSuccess, onError)),
    confirmDrawDown: (userId, payload, onSuccess) => dispatch(confirmDrawDown(userId, payload, onSuccess))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReviewDrawDownDetails);



// WEBPACK FOOTER //
// ./src/features/loans/containers/ReviewDrawDownDetails.js